<template>
  <div>
    <v-app-bar color="white" flat height="150">
      <v-toolbar-title @click="irHome()">
        <v-img width="360" src="@/assets/img/espacio-honduras.png"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="mr-4" @click="irCiat()">
        <v-img width="360" src="@/assets/img/alianza.png"></v-img>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "HeaderLogos",
  data: () => ({}),
  methods: {
    irHome() {
      this.$router.replace("/");
    },
    irCiat() {
      window.open('https://ciat.cgiar.org/?lang=es', '_blank');
    },
  },
};
</script>
